import { UNAUTHORIZED } from "constants/auth.constants";
import * as constants from "constants/externalTraining/users.constants";

import pagination from "../pagination";
import { getItemsById } from "../utils";

const initialState = {
  loading: false,
  items: [],
  itemsById: {},
  count: 0,
  showUpdateModal: false,
  allSelected: false,
  anySelected: false,
  columns: {
    email: true,
    start: true,
    location: true,
    status: true,
    tags: true,
  },
};

export const externalTrainingUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.LIST.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case constants.LIST.FAILURE:
      return {
        ...state,
        items: [],
        itemsById: {},
        count: 0,
        loading: false,
      };
    case constants.LIST.SUCCESS: {
      const { count, results: items } = action.data;
      return {
        ...state,
        items,
        itemsById: getItemsById(items),
        count: count,
        loading: false,
        allSelected: false,
        anySelected: false,
      };
    }
    case constants.SELECT: {
      let { items } = state;
      items = items.map((it) => {
        if (it.id === action.data.id) {
          it.selected = !it.selected;
        }
        return it;
      });
      return {
        ...state,
        items,
        itemsById: getItemsById(items),
        allSelected: items.every((it) => it.selected === true),
        anySelected: items.some((it) => it.selected === true),
      };
    }
    case constants.SELECT_ONE: {
      let { items } = state;

      items = items.map((it) => {
        it.selected = it.id === action.data.id;
        return it;
      });

      return {
        ...state,
        items,
        itemsById: getItemsById(items),
        allSelected: items.every((it) => it.selected === true),
        anySelected: items.some((it) => it.selected === true),
      };
    }
    case constants.SELECT_ALL: {
      let { items, allSelected } = state;

      allSelected = !allSelected;
      items = items.map((it) => {
        it.selected = allSelected;
        return it;
      });

      return {
        ...state,
        items,
        itemsById: getItemsById(items),
        allSelected,
        anySelected: items.some((it) => it.selected === true),
      };
    }
    case constants.SHOW_COLUMNS: {
      const names = action.data;
      const columns = Object.keys(state.columns);

      return {
        ...state,
        columns: columns.reduce(
          (obj, key) => ({ ...obj, [key]: names.includes(key) }),
          {},
        ),
      };
    }
    case constants.TOGGLE_UPDATE_MODAL: {
      const data = action.data;
      return {
        ...state,
        showUpdateModal: data,
      };
    }
    case UNAUTHORIZED:
      return initialState;
    default:
      return state;
  }
};

export const externalTrainingUsersPagination = pagination(
  constants.PAGINATION,
  {
    orderby: "-created",
  },
);
